import { siloPageAssetQueryStringKey } from 'app/hooks/useRoute';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { Screen } from '../../silo/shared';
import { isChecksumAddress } from '@silo/types';

export const useRouterSelectedAddress = (screen: Screen) => {
  const router = useRouter();
  const queryKey = siloPageAssetQueryStringKey(screen);

  return useMemo(() => {
    const queryValue = router.query[queryKey];
    if (!queryValue) return;

    if (Array.isArray(queryValue)) {
      console.warn('useRouterSelectedAddress: asset query string detected as an array - unusable');
      return;
    }

    if (!isChecksumAddress(queryValue)) return;

    return queryValue;
  }, [queryKey, router.query]);
};
